import { WidgetType } from '../../widgets/Widget.ts';
import { type IWidgetDirectiveType } from '../IWidgetDirectiveType.ts';
import {
  type IMarginDirective,
  MarginDirectiveSchema,
} from './IMarginDirective.ts';
import { MarginDirectiveConfigComponent } from './MarginDirectiveConfigComponent.tsx';

export const MarginDirectiveType: IWidgetDirectiveType<IMarginDirective> = {
  name: 'margin',
  key: 'margin',
  allowsWidget: (_widget, widgetType) => {
    if (
      'renderHtml' in widgetType &&
      widgetType.renderHtml &&
      widgetType.type !== WidgetType.PageBreak
    ) {
      return true;
    }
    return false;
  },
  configComponent: MarginDirectiveConfigComponent,
  configSchema: MarginDirectiveSchema,
  supportedSectionTypes: ['DOCUMENT'],
};
